import { Link } from "react-router-dom";

export default function CTABanner() {
  return (
    <section className="relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[440px]">
        {/* Left: content panel */}
        <div className="bg-[#e8632a] flex items-center px-8 lg:px-16 py-16 relative overflow-hidden">
          {/* Decorative rings */}
          <div className="absolute -bottom-20 -left-20 w-64 h-64 border-2 border-white/10 rounded-full pointer-events-none"></div>
          <div className="absolute -bottom-8 -left-8 w-40 h-40 border border-white/10 rounded-full pointer-events-none"></div>

          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-black uppercase tracking-[2px] px-4 py-2 rounded-full mb-6">
              <i className="ri-timer-flash-fill"></i>
              Fast Response · No Obligation
            </div>

            <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight mb-5">
              Ready to Get<br />
              That Tree Down?
            </h2>
            <p className="text-white/80 text-lg mb-8 max-w-sm leading-relaxed">
              We respond within hours, not days. Get your free written estimate today — no pressure, no surprise fees.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-[#e8632a] font-black rounded-xl uppercase tracking-wide hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                Request Free Estimate
              </Link>
              <a
                href="tel:+15407764488"
                className="flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-white text-white font-black rounded-xl uppercase tracking-wide hover:bg-white hover:text-[#e8632a] transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>
                Call Now
              </a>
            </div>

            <div className="flex flex-wrap gap-4 mt-6">
              {["Licensed & Insured", "Free Estimates", "15+ Years Local"].map((t) => (
                <span key={t} className="flex items-center gap-1.5 text-white/70 text-xs font-semibold">
                  <i className="ri-check-line text-white"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Right: dramatic image */}
        <div className="relative min-h-72 lg:min-h-0 overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/3a95493a55d2abf919b2cdcc52630ed8.jpg"
            alt="Professional tree removal service in action"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#1a3a2e]/30"></div>

          {/* Floating stat cards */}
          <div className="absolute top-8 right-8 bg-white rounded-2xl px-5 py-4">
            <div className="text-[#e8632a] font-black text-3xl">2,400+</div>
            <div className="text-[#1e1e1e] text-xs font-bold uppercase tracking-wide">Jobs Completed</div>
          </div>

          <div className="absolute bottom-8 right-8 bg-[#1a3a2e] text-white rounded-2xl px-5 py-4">
            <div className="flex gap-0.5 mb-1">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-yellow-400 text-sm"></i>
              ))}
            </div>
            <div className="font-black text-base">200+ Google Reviews</div>
            <div className="text-white/60 text-xs">4.9 / 5 Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
}
